export default __webpack_public_path__ + "static/media/Yelanka.57b671cc.jpeg";